import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import ListStaticSegments from './submodules/list';
import CreateStaticSegment from './submodules/create';
import EditStaticSegment from './submodules/edit/Edit';
import VersionHistorySegment from './submodules/versionHistory';

const StaticSegmentsDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.staticSegments}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.staticSegments].listStaticSegments]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListStaticSegments}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.staticSegments}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.staticSegments].createSegment]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateStaticSegment}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.staticSegments}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.staticSegments].editSegment]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/edit`}
				component={EditStaticSegment}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.staticSegments}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.staticSegments].showVersionHistory]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/showVersionHistory`}
				component={VersionHistorySegment}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default StaticSegmentsDashboard;
